import React from 'react';
import { useTranslation } from 'react-i18next';
import OpArticle, { ArticleSection } from '../components/optimus/OpArticle';

interface ProductionPortfolioDollarPageProps {
  darkMode: boolean;
}

const CODE_HEADERS = `# netlify.toml
Content-Security-Policy   = "default-src 'self'; script-src 'self' 'sha256-...';"
Strict-Transport-Security = "max-age=63072000; includeSubDomains; preload"
X-Frame-Options           = "DENY"
X-Content-Type-Options    = "nosniff"`;

const ProductionPortfolioDollarPage: React.FC<ProductionPortfolioDollarPageProps> = ({
  darkMode,
}) => {
  const { t } = useTranslation();
  const b = 'op.blog.dollar';

  const sections: ArticleSection[] = [
    { title: t(`${b}.s1t`), paragraphs: [t(`${b}.s1p1`)] },
    {
      title: t(`${b}.s2t`),
      paragraphs: [t(`${b}.s2p1`)],
      stats: [
        { value: '$1', label: t(`${b}.st1`) },
        { value: '99', label: t(`${b}.st2`) },
        { value: 'A+', label: t(`${b}.st3`) },
        { value: '1.1s', label: t(`${b}.st4`) },
      ],
    },
    { title: t(`${b}.s3t`), paragraphs: [t(`${b}.s3p1`)] },
    {
      title: t(`${b}.s4t`),
      paragraphs: [t(`${b}.s4p1`)],
      code: { filename: 'netlify.toml', content: CODE_HEADERS },
    },
    { title: t(`${b}.s5t`), paragraphs: [t(`${b}.s5p1`)] },
  ];

  const takeaways = [1, 2, 3, 4].map((n) => ({
    title: t(`${b}.k${n}t`),
    description: t(`${b}.k${n}d`),
  }));

  return (
    <OpArticle
      darkMode={darkMode}
      slug="production-portfolio-dollar"
      category={t(`${b}.category`)}
      title={t('blogPosts.productionPortfolioDollar.title')}
      description={t('blogPosts.productionPortfolioDollar.description')}
      date="2025-07-02"
      readingTime={6}
      tags={['Portfolio', 'Netlify', 'React', 'Cost Optimization', 'Case Study']}
      seoKeywords="developer portfolio for $1, netlify free tier, cheap portfolio hosting, production portfolio, cost optimization"
      sections={sections}
      takeaways={takeaways}
    />
  );
};

export default ProductionPortfolioDollarPage;
